import { NgModule } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';
import { IonicPageModule } from 'ionic-angular';
import { PlazaMissionPage } from './plaza-mission';

@NgModule({
  declarations: [
    PlazaMissionPage,
  ],
  imports: [
    IonicPageModule.forChild(PlazaMissionPage),
    TranslateModule.forChild()
  ],
})
export class PlazaMissionPageModule {}



// WEBPACK FOOTER //
// ./src/pages/plaza-mission/plaza-mission.module.ts